export class DatosProcesarFirma {
    private idProceso: string;
    private rut: string;
    private hashFirma: string;
    private email: string;
    private motivoRechazo: string;
    private tipoParticipante: string;

    constructor(id: string, rut: string, hashfirma: string, email: string, tipoParticipante: string) {
        this.idProceso = id;
        this.rut = rut;
        this.hashFirma = hashfirma;
        this.email = email;
        this.tipoParticipante = tipoParticipante;
    }

    get _id(): string {
        return this.idProceso;
    }

    get _rut(): string {
        return this.rut;
    }

    get _hashFirma(): string {
        return this.hashFirma;
    }

    get _email(): string {
        return this.email;
    }

    get _motivoRechazo(): string {
        return this.motivoRechazo;
    }
    
    get _tipoParticipnate(): string {
        return this.tipoParticipante;
    }

    set _id(value: string) {
        this.idProceso = value;
    }

    set _rut(value: string) {
        this.rut = value;
    }

    set _hashFirma(value: string) {
        this.hashFirma = value;
    }

    set _email(value: string) {
        this.email = value;
    }

    set _motivo(value: string) {
        this.motivoRechazo = value;
    }

    set _tipoParticipante(value: string) {
        this.tipoParticipante = value;
    }
}